<template>
  <div class="workflow-history-component">
    <div v-for="item in items" :key="item.id">
      <div v-if="item.activityType === 1" class="my-2">
        <AdminWorkFlowHistoryActivityComment :items="item" />
      </div>
      <div v-else class="my-2">
        <AdminWorkFlowHistoryActivityDetail :activityType="item.activityType" :items="item" />
      </div>
    </div>
  </div>
</template>

<script>
import AdminWorkFlowHistoryActivityComment from './AdminWorkFlowHistoryActivityComment.vue'
import AdminWorkFlowHistoryActivityDetail from './AdminWorkFlowHistoryActivityDetail.vue'
export default {
  name: 'workflow-history-component',
  props: {
    items: {
      type: Array,
    },
  },
  components: {
    AdminWorkFlowHistoryActivityComment,
    AdminWorkFlowHistoryActivityDetail,
  },
}
</script>
